import { Component, EventEmitter, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { apiUrl } from "src/app/global/global";
import { AdminService } from "src/app/services/admin.service";
import { Options } from "ngx-google-places-autocomplete/objects/options/options";
import { HttpParams } from "@angular/common/http";
import * as CONSTANT from "../../services/constants";
import {  Options as SliderOptions, PointerType, LabelType } from '@angular-slider/ngx-slider';
import { FormControl } from '@angular/forms';
@Component({
  selector: "app-searh-filter",
  templateUrl: "./searh-filter.component.html",
  styleUrls: ["./searh-filter.component.css"]
})
export class SearhFilterComponent implements OnInit {
  filterPersonalitiesOptions: any= [];
  filterOptions: any;
  subCatOptions: any;
  jobs: any = [];
  totalJobsCount: number = 0;
  selectedFilters: any = this._filterObject;

  options: Options = new Options({
    bounds: undefined, strictBounds: false,
    componentRestrictions: { country: "US" }
  });
  // range slider
  triggerFocus: EventEmitter<PointerType> = new EventEmitter<PointerType>();
  sliderMin: number = 0;
  sliderMax: number = 0;
  sliderOptions: SliderOptions = {
    floor: 0,
    ceil: 100000,
    // step: 1,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return "$" + value + "";
        case LabelType.High:
          return "$" + value + "";
        default:
          return "$" + value + "";
      }
    }
  };
  PointerType: any = PointerType;
  showSubCategory:boolean=false;
  showRedDot:boolean=false;
  searchKey:any;
  currentPage:any;
  pagination = {limit: CONSTANT.LIMIT, maxSize: CONSTANT.MAX_SIZE, skip: 0, totalItems: ""}
  rangeSlider = new FormControl([100, 350]);
  constructor(private api: AdminService, private router: Router, private activateRoute: ActivatedRoute) {
    this.activateRoute.paramMap.subscribe((x) => {
      this.selectedFilters = this._filterObject;
      this.selectedFilters.search = x.get("search");
      this.searchKey =this.selectedFilters.search
      this.resetJobsAndGetSearch(true);
    })

    this.activateRoute.queryParams.subscribe((rs) => {
      if (rs.filters) {
        var x = JSON.parse(rs.filters);
        Object.keys(x).forEach((pkey) => {
          Object.keys(this.selectedFilters).forEach((fkey) => {
            if (pkey == fkey) {
              this.selectedFilters[fkey] = x[pkey];
            }
          })
        })
        // this.resetJobsAndGetSearch();
      }
    })

  }

  ngOnInit(): void {
    this.getFilterOptions();
  }
// total :{value: 27, relation: "eq"}
  getFilterOptions() {
    this.api.getDatas(apiUrl._getFilterOptions).subscribe((res) =>{ 
      this.filterOptions = res.data;
      this.filterOptions.workPlace = [];
      this.filterOptions.employmentTypes = [];
      this.filterOptions.categories = [];
      this.filterOptions.eligible = [];
      this.filterOptions.benefits = [];
      this.filterOptions.industry = [];
      this.subCatOptions =[];
      this.filterPersonalitiesOptions = this.filterOptions.personalities.rows.sort((a, b) => a.title > b.title ? 1 : -1);
      this.filterOptions.personalities.rows = [];
      // this.filterOptions.personalities.rows = this.filterOptions.personalities.rows.sort((a, b) => a.title > b.title ? 1 : -1);
    });
  }

  
  onAddressChange(address: any) {
    this.selectedFilters.location = address.formatted_address;
    this.selectedFilters.latitude = address.geometry.location.lat().toString();
    this.selectedFilters.longitude = address.geometry.location.lng().toString();
    // this.refreshFilters();
  }

  onDesiredSalaryChange(event, key) {
    this.selectedFilters[key] = event.target.value;
    // this.refreshFilters();
  }

  onPayoutTypeChange(event) {
    this.selectedFilters.rate = event.target.value;
    // this.refreshFilters();
  }

  onFilterOptionChange(event, option, type) {
    if (type == "categoryId") {
      this.selectedFilters[type] = [];
      this.showSubCategory=false;
      this.selectedFilters["specializationId"] = [];
      this.subCatOptions = [];
    }
    if (event.target.checked) {
      this.selectedFilters[type].push(option.id);
      if (type == "categoryId") {
        this.showSubCategory=true;
        this.selectedFilters['subCategories'] = [];
       // this.getSubCatFilterOptions(option.id);
      }
    } else {
      // this.selectedFilters[type] = this.selectedFilters[type].filter((x) => x !== option.id);
      this.selectedFilters[type] = this.selectedFilters[type].filter((x) => x !== option.id);
    }
    this.api.showLoader = false;
    this.refreshFilters();
    this.currentPage = 1;
    this.getSearchData(false);
  }

  toggleFilterChekbox(optionId, key) {
    return this.selectedFilters[key].indexOf(optionId) == -1 ? false : true;
  }
  getSubCatFilterOptions(catID) { 
    let catId =catID
    let params = new HttpParams(); 
    params = params.append("categoryId", catId);
    this.api.getData(apiUrl._jobgetSubCategories,params).subscribe((res) => this.subCatOptions = res.data.data);
  }
  onSorting(sortingType) {
    if (sortingType != "alphabetical") this.selectedFilters.sortBy = sortingType;
    if (sortingType == "ending") this.selectedFilters.sortBy = "updatedAt";
    this.selectedFilters.orderBy = (sortingType == "alphabetical" || sortingType == "ending") ? "asc" : "desc";
    this.showRedDot= true
    this.refreshFilters();
    this.resetJobsAndGetSearch(false);
  }

  refreshFilters() {
    this.router.navigate(["/search/" + this.searchKey])
    // this.router.navigate(["/search/" + this.selectedFilters.search], { queryParams: { filters: this.filtersIntoString } })
    // this.resetJobsAndGetSearch();
  }

  resetJobsAndGetSearch(resetFilters) {
    // this.jobs = [];
    // this.selectedFilters.skip = 1;
    this.currentPage = 1;
    this.getSearchData(resetFilters);
  }

  onJobSaved(job: any) {
    // job.saveStatus = job.saveStatus == 1 ? 0 : 1;
  }

  getSearchData(setFilters) {
    if(this.sliderMin == 0 && this.sliderMax == 0){
      this.selectedFilters.minimum = null;
      this.selectedFilters.maximum = null;
    } else{
      this.selectedFilters.minimum = this.sliderMin;
      this.selectedFilters.maximum = this.sliderMax;
    }
    setTimeout(() => {
      var request = Object.keys(this.selectedFilters).
      filter((key) => this.selectedFilters[key] instanceof Array ? this.selectedFilters[key].length > 0 : this.selectedFilters[key] != null).
      reduce((cur, key) => { return Object.assign(cur, { [key]: this.selectedFilters[key] }) }, {});
      request["limit"] =this.pagination.limit.toString()
      request["skip"] =this.currentPage
      // this.jobs = []
      this.api.postData(apiUrl._searchJobs, request).subscribe((x) => {
        if((x.data.aggregation) && (setFilters)) {
          this.resetFilterOptions(x.data.aggregation, true)
        } else if ((this.showSubCategory) &&  (x.data.aggregation)) {
          this.resetFilterOptions(x.data.aggregation, false)
        }
        this.totalJobsCount = x.data.hits.total.value; 
        this.pagination.totalItems = x.data.hits.total.value; 
        if(x.data.hits.hits != ""){
       // this.jobs = [...this.jobs, ...x.data.hits.hits];
       this.jobs = x.data.hits.hits;
       // Array.prototype.push.apply(this.jobs, x.data.hits.hits);
      } else{
        this.jobs = []
      } 
      })
    }, 500);
  }
  resetFilterOptions(lists, loadAll): void {
    if(loadAll) {
      this.filterOptions.workPlace = lists.workPlace || [];
      this.filterOptions.employmentTypes = lists.employmentTypes || [];
      this.filterOptions.categories = lists.categories || [];
      this.filterOptions.eligible = lists.eligible || [];
      this.filterOptions.benefits = lists.benefits || [];
      this.filterOptions.industry = lists.industry || [];
      this.filterOptions.personalities.rows =[];
      if(lists.personalities) {
        this.filterPersonalitiesOptions.forEach(element => {
          element.count = 0;
          lists.personalities.some(k1 => {
            if(k1.key == element.id)  {
              element.count = k1.doc_count;
              this.filterOptions.personalities.rows.push(element);
            }
          });
            
        });
      }
      this.subCatOptions = [];
    } else {
      this.subCatOptions = lists.subCategories || [];
    }
  }
 
  pageChanged(event: any): void {
    if (event == this.currentPage) return;
    this.currentPage = event;
    this.pagination.skip = (event - 1) * this.pagination.limit;
    window.scroll(0, 0);
    this.getSearchData(false);
  } 
  
  applyFilter(){
    this.currentPage = 1
    this.getSearchData(false);
  }
   
  onClearFilters() {
    this.sliderMin =0
    this.sliderMax =0
    this.selectedFilters = this._filterObject; 
    this.selectedFilters.search = this.searchKey;
    this.showSubCategory=false;
    let body = document.querySelectorAll(".accordion-drawer__trigger");
    for(let i=0; i < body.length; i++){
      let data = body[i] as HTMLInputElement
      data.checked = false;
    }
    this.router.navigate(["/search/" + this.searchKey]);
    this.currentPage = 1;
    this.getSearchData(true);
  }

  get filtersIntoString() {
    var request = Object.keys(this.selectedFilters).
      filter((key) => this.selectedFilters[key] instanceof Array ? this.selectedFilters[key].length > 0 : this.selectedFilters[key] != null).
      reduce((cur, key) => { return (key == "minimum" || key == "maximum") ? Object.assign(cur, { [key]: parseInt(this.selectedFilters[key]) }) : Object.assign(cur, { [key]: this.selectedFilters[key] }) }, {});
    return JSON.stringify(request);
  }

  onModalScrollDown() {
    this.selectedFilters.skip = this.selectedFilters.skip + 1;
    this.getSearchData(false);
  }

  get _filterObject() {
    return {
      limit: 10,
      skip: 1,
      search: "",
      sortBy: null,
      orderBy: null,
      latitude: null,
      longitude: null,
      location: null,
      minimum: null,
      maximum: null,
      rate: null,
      industryId: [],
      employementTypeId: [],
      categoryId: [],
      subCategories: [],
      benefitsId: [],
      personalitiesIds: [],
      jobEligibleForId: [],
      workPlaceLocation: [],
    };
  }
}